export const CREATE_ACCOUNT_TEXT = 'Create a Big O Tires account today to save your appointment details for later.'
export const CREATE_ACCOUNT_TITLE = 'Create An Account.'
